export const STRINGS = {
  questions_concerns: 'Questions or concerns?',
  lets_talk: "Let's Talk",
};
